export default __webpack_public_path__ + "locales/sl/OAuth.json?hash=c1c8e99a58cff6335629f2e85cec56ed";